import axios from 'axios';
import { apiBaseUrl } from 'App';
import { getCsrfToken } from './csrfFunctions';
import { loadSessionData, LoginCallbacks, LoginResponse } from './loadSessionData';

interface SwitchEnvironmentParams {
    environment_hash: string;
    utc_datetime: string;
    callbacks: LoginCallbacks;
}

export const switchEnvironment = async ({ environment_hash, utc_datetime, callbacks }: SwitchEnvironmentParams) => {
    // Get the csrf token   
    const csrfToken = getCsrfToken();

    try {
        const response = await axios.post<LoginResponse>(
            `${apiBaseUrl}/switch_environment_as_superuser/`,
            {
                environment_hash,
                utc_datetime
            },
            {
                withCredentials: true,
                headers: {
                    'X-CSRFToken': csrfToken
                }
            }
        );

        // Load the session data
        loadSessionData({
            responseData: response.data,
            callbacks
        });

        // Return success
        return { 
            status: 'success', 
            redirect: response.data.environment_data.redirect_to,
            data: response.data 
        };
    } catch (error: any) {
        throw new Error(
            error?.message || 'Failed switching environment'
        );
    }
};